import { render, staticRenderFns } from "./CalendarIndex.vue?vue&type=template&id=b5c551d8&scoped=true"
import script from "./CalendarIndex.vue?vue&type=script&lang=js"
export * from "./CalendarIndex.vue?vue&type=script&lang=js"
import style0 from "./CalendarIndex.vue?vue&type=style&index=0&id=b5c551d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c551d8",
  null
  
)

export default component.exports